import { render, staticRenderFns } from "./software.vue?vue&type=template&id=0ebcd3b4&scoped=true&"
import script from "./software.vue?vue&type=script&lang=js&"
export * from "./software.vue?vue&type=script&lang=js&"
import style0 from "./software.vue?vue&type=style&index=0&id=0ebcd3b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebcd3b4",
  null
  
)

export default component.exports